// §10.6: live cycle counters card. Re-derives from the events array
// every render — never persisted on the opportunity.

import React from 'react';
import { Card } from '../../../ui';
import type { OpportunityEvent } from '../../../types/pipeline';
import { computeCounters } from './state';

interface Props {
  events: OpportunityEvent[];
  currentCycle: number;
}

const DealCycleCounters: React.FC<Props> = ({ events, currentCycle }) => {
  const counters = computeCounters(events, currentCycle);
  return (
    <Card padding="tight">
      <div className="text-[11px] uppercase tracking-wide text-slate-400 font-mono mb-2">
        Cycle counters · live
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <Counter value={counters.cycles} label="cycles" />
        <Counter value={counters.reopens} label="reopens" />
        <Counter value={counters.won} label="won" valueClass="text-ok-text" />
        <Counter
          value={counters.lost}
          label="losses logged"
          valueClass="text-danger-text"
        />
      </div>
    </Card>
  );
};

const Counter: React.FC<{
  value: number;
  label: string;
  valueClass?: string;
}> = ({ value, label, valueClass }) => (
  <div>
    <div className={`font-mono text-2xl font-semibold ${valueClass ?? 'text-slate-50'}`}>
      {value}
    </div>
    <div className="text-[10px] text-slate-400">{label}</div>
  </div>
);

export default DealCycleCounters;
